<p>
  <strong>You are about to delete <span>{{numberOfConversationIds}}</span> conversations.</strong>
</p>
<p>
  If you delete these conversations, the above references and all associated records will be permanently deleted and <u>cannot be restored</u>.
</p>
<p>
  <strong>Are you sure you want to delete these conversations?</strong>
</p>
